import { tenantIdStorage } from "@sg-protect/core";
import { useTenants, useUserIdentification } from "@sg-protect/shell";
import { useEffect, useState } from "react";

export function useSyncPrimaryTenant() {
    const primaryTenantId = useTenants().tenants?.primaryTenant?.id ?? null;
    const { identifyTenant } = useUserIdentification();

    // Setup clears the stored tenant, so each layout puts it back before its pages send their first request.
    useState(() => {
        if (tenantIdStorage.get() !== primaryTenantId) {
            tenantIdStorage.set(primaryTenantId);
        }
    });

    useEffect(() => {
        identifyTenant(primaryTenantId);
    }, [identifyTenant, primaryTenantId]);
}
